import { useFormContext } from 'react-hook-form';
import { CounterFormatPreviewBanner } from '../../CounterFormatPreviewBanner';
import { CreditNoteFormValues } from './formMapping';

export const CreditNoteCounterPreviewBanner = () => {
    const { watch } = useFormContext<CreditNoteFormValues>();

    const numberOfDigits = watch('numberOfDigits');
    const prefix = watch('prefix');
    const startValue = watch('startValue');

    return (
        <CounterFormatPreviewBanner
            numberOfDigits={numberOfDigits}
            prefix={prefix}
            suffix={null}
            startValue={startValue}
        />
    );
};
